import { FC, useCallback, useState } from 'react';
import { Button, Input, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { $fm, $t } from '@/Intl';
import './ICEContacts.less';

// ice联系人
const ICEContacts: FC<CustomFieldsProps> = (props) => {
  const { value, onChange } = props;
  const [num, setNum] = useState('');
  const valAry = (value || '').split(',');

  const handleAdd = useCallback(() => {
    let v = num?.trim?.();
    if (v && onChange) {
      if (valAry.includes(v)) {
        return message.error($t('ICE_CONTACT_ERROR'));
      }

      let tmp = [...valAry, v].filter((v) => v);

      onChange(tmp.join(','), tmp.length);

      setNum('');
    }
  }, [onChange, valAry, num]);

  const handleDelete = useCallback(
    (i: number) => {
      valAry.splice(i, 1);
      onChange && onChange(valAry.join(','), valAry.length);
    },
    [valAry, onChange],
  );

  return (
    <div className='ice-contacts'>
      <div>
        <Input
          className='ice-contacts-input'
          value={num}
          onChange={(e) => setNum(e.target.value)}
        />
        <Button
          className='ice-contacts-add-btn'
          onClick={handleAdd}
          type='primary'
        >
          {$fm('ADD')}
        </Button>
      </div>
      <ul>
        {valAry
          .filter((v) => v)
          .map((val, i) => (
            <li key={val}>
              <span className='contact-title'>{val}</span>{' '}
              <DeleteOutlined
                className='icon-delete'
                onClick={() => handleDelete(i)}
              />
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ICEContacts;
